/** The daily goal of new words a learner starts with until they choose one. */
export const DEFAULT_WORDS_PER_DAY = 5;
